module.exports = __webpack_public_path__ + "static/media/front-direct-image-1.fd6bf259.png";